export function CircularProgress({ percentage, size = 100, strokeWidth = 10, color = '#10b981', decimals = 0 }: {
  /** null = no data to divide by (METRIC-DEFINITIONS Q13): the ring stays empty and reads "N/A". */
  percentage: number | null
  size?: number
  strokeWidth?: number
  color?: string
  decimals?: number
}) {
  const radius = (size - strokeWidth) / 2
  const circumference = radius * 2 * Math.PI
  const isNA = percentage === null || Number.isNaN(percentage)
  const offset = isNA ? circumference : circumference - (percentage / 100) * circumference
  const label = isNA
    ? 'N/A'
    : (decimals > 0 ? percentage.toFixed(decimals) : Math.round(percentage).toString()) + '%'
  const ringColor = isNA ? '#9ca3af' : color
  // Scale the label down as it grows (decimal displays like "96.2%") so it
  // always fits inside the ring instead of overflowing the stroke.
  const innerDiameter = size - strokeWidth * 2
  const fontSize = Math.max(10, Math.min(size * 0.3, (innerDiameter * 1.7) / label.length))

  return (
    <div className="relative inline-flex items-center justify-center">
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={ringColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-500 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-bold" style={{ fontSize: `${fontSize}px` }}>{label}</span>
      </div>
    </div>
  )
}
